import { ButtonsModule } from './../button/button.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TooltipComponent } from './tooltip.component';
import { TooltipDataSharedService } from './tooltip.dataSharedService';
import { IconModule } from './../icon/icon.module';
import { TooltipDirective } from './tooltip.directive';
@NgModule({
  imports: [
    ButtonsModule,
    CommonModule,
    IconModule
  ],
  declarations: [
    TooltipComponent,
    TooltipDirective
  ],
  entryComponents: [TooltipComponent],
  exports: [TooltipDirective],
  providers: [
    TooltipDataSharedService
  ]
})
export class TooltipModule {}
